import { render, staticRenderFns } from "./ButtonEditor.vue?vue&type=template&id=3bc645e4&"
import script from "./ButtonEditor.vue?vue&type=script&lang=js&"
export * from "./ButtonEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports